import React from 'react'
import styled from 'styled-components'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import useLayiFrame, { FRAME_STATUS, LAYI_FRAME_SRC } from '../../chatbot/useLayiFrame'
import { pillLooks } from '../UIComponents/StyledButtons'

// The embedded LAYI: the native Chainlit UI served same-origin under /layi, in an iframe that fills
// whatever box it is given (the chat page and the floating panel size it). The hook logs in first
// and heals a lost session; this component only renders the three states.

// The surface is the deep navy of the top bar and of LAYI's own dark background, so the frame keeps
// its colour when the chat paints over it.
export const layiPalette = {
  surface: themeColors.deepblueColor3,
  text: themeColors.whiteColor,
  textMuted: themeColors.whiteTransparent06
}

const Frame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: ${layiPalette.surface};
`

const Status = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: ${layiPalette.surface};
  color: ${layiPalette.textMuted};
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  text-align: center;
`

// The app's outline pill: a mint contour that fills mint under the pointer.
const RetryButton = styled.button`
  border: none;
  padding: 8px 18px;
  font-family: 'Raleway', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  ${pillLooks.outline};
`

export default function LayiFrame({ locale, t }) {
  const { status, epoch, frameRef, retry } = useLayiFrame({
    locale,
    notificationTitle: t('layi_notification_title'),
    notificationBody: t('layi_notification_body')
  })

  if (status.kind === FRAME_STATUS.ERROR) {
    return (
      <Status role="alert">
        <span>{t(status.messageKey)}</span>
        <RetryButton type="button" onClick={retry}>
          {t('retry')}
        </RetryButton>
      </Status>
    )
  }

  if (status.kind === FRAME_STATUS.LOGIN) {
    return <Status role="status">{t('layi_status_connecting')}</Status>
  }

  // styled-components v3 hands the DOM node to `innerRef` (a plain `ref` gives the wrapper instance).
  return <Frame key={epoch} innerRef={node => (frameRef.current = node)} src={LAYI_FRAME_SRC} title="LAYI" />
}
